import TabPage from "./../factories/tab-page";
import TabController from "./../factories/tab-controller";
import BaseViewModel from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialog from "./../factories/bao-dialog";
import "./../bindings/bao-date-time-box";
import "./../bindings/bao-date-time-picker";


// System UI class for edit System settings
class System extends BaseViewModel {
    
    Value: KnockoutObservable<string> = ko.observable();
    FieldType: KnockoutObservable<string> = ko.observable();
    IsValueChecked: KnockoutObservable<boolean> = ko.observable();
    RegxValidator: KnockoutObservable<string> = ko.observable();


    public constructor(tabPage: TabPage) {
        super(tabPage);
        this.IsValueChecked.subscribe((value) => {
            if (this.FieldType() == "bool" && value != null) {
                this.Value(value.toString());
            }
        });
    }

    public CompleteCheck(): JQueryPromise<boolean> | boolean {
        let completed: boolean = true;

        if (this.FieldType() == "text" && this.Value() && this.RegxValidator()) {
            let regxValidator= new RegExp(this.RegxValidator());

            if (!regxValidator.test(this.Value())) {
                completed = false;
            }
        }

        if (!completed) {
            let baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgNotValid"), "info");
        }
        return completed;
    }
    public InitUrl(): string {
        return "System/Init";
    }
    public init(): JQueryPromise<void> {
        return super.init();
    }
   
}
export default System;